"use strict";
/**
 * Created by Marvin on 26.04.17.
 */
exports.__esModule = true;
exports.HIDE_MODAL = exports.SHOW_MODAL = void 0;
var PREFIX = '@@wikom-modal/';
exports.SHOW_MODAL = PREFIX + 'SHOW_MODAL';
exports.HIDE_MODAL = PREFIX + 'HIDE_MODAL';
